import React from 'react';
import { Badge } from '@mantine/core';

// Subtle-but-visible "DRAFT / Work in progress" marker for pre-release feature pages.
// Single source of truth for the label + styling so every draft page reads identically.
export default function DraftBadge({ mb = 'xs', ...props }) {
  return (
    <Badge color="orange" variant="light" size="sm" radius="sm" mb={mb} title="Work in progress" {...props}>
      DRAFT · Work in progress
    </Badge>
  );
}
